module.exports = __webpack_public_path__ + "img/logo_bkb_borobudur_single.6f0aacd0.png";